import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {hideModal, SELECT} from '../../../modules/modals'
import {connect} from 'react-redux'
import ReactSelect from 'react-select'


class Select extends Component {
    constructor(props) {
        super(props)
        const {initValue = {}} = props
        this.state = {
            value : initValue
        }
    }
    render() {
        let {zIndex, title, selectTxt, okButtonTxt, cancelButtonTxt, options, clearable = true} = this.props
        let {formatMessage} = this.context
        if (!okButtonTxt) okButtonTxt = formatMessage('Choose')
        if (!cancelButtonTxt) cancelButtonTxt = formatMessage('Cancel')
        return (
            <Modal
                isOpen={true}
                style={{
                    overlay: {zIndex},
                }}
                onRequestClose={this.handleClose}
                overlayClassName="custom-modal"
                className="custom-modal-content create-dialog-modal-content"
            >
                <div className="create-dialog-modal-content__header">
                    <div className="create-dialog-modal-content__title">{title}</div>
                    <div
                        onClick={this.handleClose}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className="create-dialog-modal-content__body select_modal">
                    <form className="create-dialog-form">
                        <div className="create-dialog-form__group create-dialog-form__group--indent-bottom">
                            <label>{selectTxt}</label>
                            <ReactSelect
                                valueKey = "id"
                                labelKey = "name"
                                options = {options}
                                value = {this.state.value}
                                onChange={this.onSelect}
                                clearable = {clearable}
                            />
                        </div>
                        <div className="create-dialog-form__group flex">
                            <button
                                onClick={this.handleOkClick}
                                className="btn btn-primary mr-auto"
                                type="button"
                            >{okButtonTxt}</button>
                            <button
                                onClick={this.handleClose}
                                className="btn btn-warning"
                                type="button"
                            >{cancelButtonTxt}</button>
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }

    handleOkClick = () => {
        const {okCb} = this.props
        okCb(this.state.value)
    }

    onSelect = (value) => {
        this.setState({value})
    }

    handleClose = () => this.props.hideModal({modalType: SELECT})
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    null,
    {hideModal}
)(Select)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/Select.js